module.exports = __webpack_public_path__ + "static/media/kv-zh-Hant.45b0d5d7.png";